module.exports = {
  cancel: 'Cancel',
  cancel_upload: 'Cancel upload',
  messages: 'Messages',
  no_users_found: 'No users found',
  search_users: 'Search users',
  search_chat: 'Search chat',
  last_messages: 'Last messages ({count})',
  you_do_not_have_any_messages_yet: 'You don\'t have any messages yet.',
  look_and_select_person_to_message: 'Why don\'t you look for the person you prefer to work with and write to them?',
  is_typing: 'is typing',
  thread_inactive: '{username} is not available to chat with anymore.',
  delete_chat: {
    title: 'Delete chat message',
    content: 'Are you sure you want to delete this message?',
    confirm_deletion: 'Delete',
  },
  message_context_menu: {
    delete: 'Delete message',
    reply: 'Reply',
  },
  no_messages_found: 'No messages found match your search criteria.',
  users: 'Users',
  thread_has_no_messages_title: 'This is the start of your direct messages with',
  you: 'You',
  image: 'Image',
  attachment: 'Attachment',
  send: 'Send',
  no_access_tooltip: "{username} doesn't have access to this content.",
  media_empty_title: 'No media added',
  media_empty_description: 'Send images, videos, files or links to show them here.',
  write_a_message: 'Write a message...',
  chat_empty_title: 'No ongoing chats',
  chat_empty_description: 'Search for a contact and start your conversation!',
  uploading: 'Uploading...',
  push_prompt: {
    title: 'Want to get notified about new messages?',
    description: 'Get notified about new messages even when you\'re not on this page.',
    enable: 'Enable',
    not_now: 'No',
    failed_to_enable: 'Failed to enable browser notifications',
  },
  auto_translate_prompt: {
    title: 'Always translate messages in this chat?',
    description: 'Translate incoming messages automatically to your language.',
    enable: 'Always translate',
    not_now: 'Not now',
    failed_to_enable: 'Failed to enable auto-translate',
  },
  auto_translate_toggle: {
    label: 'Auto-translate messages',
    warning: 'AI translations can be incorrect or misleading. Double-check relevant information with {username} when using AI translations.',
  },
  media_tabs: {
    images: 'Images',
    files: 'Files',
    links: 'Links',
  },
  translate: 'Translate',
  ai_translated_show_original: 'AI translation (show original)',
  reactions: {
    add: 'Add reaction',
    remove: 'Remove reaction',
    picker_title: 'Add a reaction',
  },
  deleted_message: 'Deleted message',
}
